import React, { useEffect, useState } from "react";
import fetchData from "../../../../api/fetchApi";
import { Trash2, Edit } from "lucide-react";
import { useParams } from "react-router-dom";
import Table from "../../../common/Table";

export default function AccountTransactionsPage() {
  const { id } = useParams();
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  // Pagination and filtering state
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [filters, setFilters] = useState({});

  // Derived paginated/filterable data
  const members = transactions.slice((currentPage - 1) * perPage, currentPage * perPage);

  // Dummy refresh function for filters
  const refreshMembers = () => {
    // In a real app, you would re-fetch data with filters
    setCurrentPage(1);
  };

  const handleFetch = async () => {
    setLoading(true);
    setError(null);
    setTransactions([]);
    try {
      // Build query params for filters and pagination
      const params = new URLSearchParams();
      params.append('page', currentPage);
      params.append('perPage', perPage);
      Object.entries(filters).forEach(([key, value]) => {
        if (value) params.append(key, value);
      });
      const url = `finance/accounts/${id}/transactions?${params.toString()}`;
      const data = await fetchData(url);
      setTransactions(data.data || []);
      // Set total pages for pagination (from API if available, else fallback)
      setTotalPages(data.totalPages || Math.ceil((data.data?.length || 1) / perPage));
    } catch (err) {
      setError(err.message || "حدث خطأ أثناء جلب البيانات");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    handleFetch();
    // eslint-disable-next-line
  }, [id, perPage, currentPage, filters]);

  const columns = [
    {
      header: "المستخدم",
      accessor: "user_name",
      render: (row) => row.user?.name || "-",
    },
    {
      header: "رقم الجوال",
      accessor: "user_mobile",
      render: (row) => row.user?.mobile || row.user?.phone || "-",
    },
    {
      header: "البريد الإلكتروني",
      accessor: "user_email",
      render: (row) => row.user?.email || "-",
    },
    {
      header: "المبلغ",
      accessor: "amount",
    },
    {
      header: "النوع",
      accessor: "type",
    },
    {
      header: "الوصف",
      accessor: "description",
    },
    {
      header: "المرجع",
      accessor: "reference",
      render: (row) => row.reference || row.reference_id || "-",
    },
    {
      header: "تاريخ الإنشاء",
      accessor: "created_at",
      render: (row) => row.created_at ? new Date(row.created_at).toLocaleString() : "-",
    },
  ];

  const act = [
    {
      label: "حذف",
      onClick: (row) => {
        // TODO: Implement delete logic
        alert(`حذف المعاملة رقم ${row.id}`);
      },
      icon: <Trash2 size={16} />,
    },
    {
      label: "تفاصيل المعاملة",
      onClick: (row) => {
        // TODO: Implement details logic
        alert(`تفاصيل المعاملة رقم ${row.id}`);
      },
      icon: <Edit size={16} />,
    },
  ];

  return (
    <div className="mx-auto p-6 bg-white rounded shadow text-right" dir="rtl">
      <h2 className="text-xl font-bold mb-4">معاملات الحساب</h2>
      {loading && <div className="text-gray-500">جاري التحميل...</div>}
      {error && <div className="text-red-600 mb-2">{error}</div>}
      <Table
        columns={columns}
        rows={members}
        act={act}
        pagination={{
          title: "المعاملات",
          label: `الصفحة ${currentPage} من ${totalPages}`,
          pages: Array.from({ length: totalPages }, (_, i) => i + 1),
          current: currentPage,
          last: totalPages,
          onPageChange: setCurrentPage,
          perPage: perPage,
          onPerPageChange: setPerPage,
        }}
        filters={filters}
        setFilters={setFilters}
        onFilter={refreshMembers}
      />
      {!loading && transactions.length === 0 && !error && (
        <div className="text-gray-500 mt-4">لا توجد معاملات لهذا الحساب.</div>
      )}
    </div>
  );
}
